import { render, staticRenderFns } from "./ModalActiveAccount.vue?vue&type=template&id=17ddde1a&scoped=true"
import script from "./ModalActiveAccount.vue?vue&type=script&lang=js"
export * from "./ModalActiveAccount.vue?vue&type=script&lang=js"
import style0 from "./ModalActiveAccount.vue?vue&type=style&index=0&id=17ddde1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ddde1a",
  null
  
)

export default component.exports